import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-c6-six-three-one',
  templateUrl: './c6-six-three-one.component.html',
  styleUrls: ['./c6-six-three-one.component.scss']
})
export class C6SixThreeOneComponent implements OnInit {
  pdfSrc: string[] = ['/assets/pdf/NAAC/Criterion-6/Teacher welfare Policy.pdf'];
  src: string;
  constructor() { }

  ngOnInit(): void {
    this.src = this.pdfSrc[0];
  }
}
